import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class UpdateOrderItem
*  Информация о продукте в заказе
*/
export class UpdateOrderItem extends ActiveModel {

  /**
  * productId
  * Идентификатор продукта<br>  */
  @ActiveField(0)
  productId: number = 0


  /**
  * amount
  * Кол-во единиц продукта в заказе<br>  */
  @ActiveField(0)
  amount: number = 0
}
